function lockScroll() {
  const scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.dataset.scrollY = scrollY;
}

function unlockScroll() {
  const scrollY = document.body.dataset.scrollY;
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0'));
}

// Listen for changes on any <details> element with the mobile menu
document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('details-disclosure[aria-label="Primary menu"] details');

  if (!menu) return;

  menu.addEventListener('toggle', () => {
    if (menu.open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  });
});
